/**
 * Whether the "Reduce translation marks" option is shown (DESIGN UD-34): when the document has a translated pattern (the
 * rule before ED-160) or TR-01 fires. TR-01 fires here by the document rule of ENGINE-SPEC §9.3: its score reaches
 * FIRE_MIN_SCORE with a data weight above FIRE_MIN_KAPPA (the same constants the engine's `channelFiring` uses).
 */
import { FIRE_MIN_KAPPA, FIRE_MIN_SCORE } from '../../engine/bench/directives.ts';
import type { ChannelRow } from '../../engine/ensemble/index.ts';
import type { ViewModel } from '../../shared/viewmodel.ts';

type Ensemble = Pick<ViewModel['ensemble'], 'patterns' | 'channels'>;

/** TR-01 fires on the document's own score (a segment-only firing is not visible in the ensemble rows). */
export function tr01Fires(channels: ReadonlyArray<ChannelRow>): boolean {
	const r = channels.find((c) => c.id === 'TR-01');
	return (
		r !== undefined &&
		r.status === 'scored' &&
		(r.score ?? 0) >= FIRE_MIN_SCORE &&
		(r.kappa ?? 0) > FIRE_MIN_KAPPA
	);
}

export function showTranslationOption(e: Ensemble): boolean {
	return e.patterns.some((p) => p.kind === 'translated') || tr01Fires(e.channels);
}
